module.exports = __webpack_public_path__ + "static/media/service-farm-logo.fb7e20cd.png";